import React from 'react';

import Loader from '../loader';
import axios from '../axios';
import compressImage from '../../lib/image_compressor';

const SectionImage = ({
  images,
  setExpenseApplicationImages,
  expenseApplication,
}) => {
  const [loadingSub1, setLoadingSub1] = React.useState(false);
  const [loadingSub2, setLoadingSub2] = React.useState(false);
  const [loadingSub3, setLoadingSub3] = React.useState(false);
  const [loadingSub4, setLoadingSub4] = React.useState(false);
  const [loadingSub5, setLoadingSub5] = React.useState(false);
  const [loadingSub6, setLoadingSub6] = React.useState(false);
  const [loadingSub7, setLoadingSub7] = React.useState(false);
  const [loadingSub8, setLoadingSub8] = React.useState(false);
  const [loadingSub9, setLoadingSub9] = React.useState(false);
  const [loadingSub10, setLoadingSub10] = React.useState(false);
  const subImageRef1 = React.useRef(null);
  const subImageRef2 = React.useRef(null);
  const subImageRef3 = React.useRef(null);
  const subImageRef4 = React.useRef(null);
  const subImageRef5 = React.useRef(null);
  const subImageRef6 = React.useRef(null);
  const subImageRef7 = React.useRef(null);
  const subImageRef8 = React.useRef(null);
  const subImageRef9 = React.useRef(null);
  const subImageRef10 = React.useRef(null);

  const subImage1 = React.useMemo(() => {
    return images[0] || {};
  }, [images]); // ex: {id: 1, photo_url_medium: 'https://...'}
  const subImage2 = React.useMemo(() => {
    return images[1] || {};
  }, [images]);
  const subImage3 = React.useMemo(() => {
    return images[2] || {};
  }, [images]);
  const subImage4 = React.useMemo(() => {
    return images[3] || {};
  }, [images]);
  const subImage5 = React.useMemo(() => {
    return images[4] || {};
  }, [images]);
  const subImage6 = React.useMemo(() => {
    return images[5] || {};
  }, [images]);
  const subImage7 = React.useMemo(() => {
    return images[6] || {};
  }, [images]);
  const subImage8 = React.useMemo(() => {
    return images[7] || {};
  }, [images]);
  const subImage9 = React.useMemo(() => {
    return images[8] || {};
  }, [images]);
  const subImage10 = React.useMemo(() => {
    return images[9] || {};
  }, [images]);

  const createImage = React.useCallback(() => {
    if (!subImage1.image_url_medium) {
      subImageRef1.current.click();
    } else if (!subImage2.image_url_medium) {
      subImageRef2.current.click();
    } else if (!subImage3.image_url_medium) {
      subImageRef3.current.click();
    } else if (!subImage4.image_url_medium) {
      subImageRef4.current.click();
    } else if (!subImage5.image_url_medium) {
      subImageRef5.current.click();
    } else if (!subImage6.image_url_medium) {
      subImageRef6.current.click();
    } else if (!subImage7.image_url_medium) {
      subImageRef7.current.click();
    } else if (!subImage8.image_url_medium) {
      subImageRef8.current.click();
    } else if (!subImage9.image_url_medium) {
      subImageRef9.current.click();
    } else if (!subImage10.image_url_medium) {
      subImageRef10.current.click();
    }
  }, [subImage1, subImage2, subImage3, subImage4, subImage5, subImage6, subImage7, subImage8, subImage9, subImage10]);

  const updateSubImage = React.useCallback((subImageIndex) => {
    if (subImageIndex === 1) {
      subImageRef1.current.click();
    } else if (subImageIndex === 2) {
      subImageRef2.current.click();
    } else if (subImageIndex === 3) {
      subImageRef3.current.click();
    } else if (subImageIndex === 4) {
      subImageRef4.current.click();
    } else if (subImageIndex === 5) {
      subImageRef5.current.click();
    } else if (subImageIndex === 6) {
      subImageRef6.current.click();
    } else if (subImageIndex === 7) {
      subImageRef7.current.click();
    } else if (subImageIndex === 8) {
      subImageRef8.current.click();
    } else if (subImageIndex === 9) {
      subImageRef9.current.click();
    } else if (subImageIndex === 10) {
      subImageRef10.current.click();
    }
  }, []);

  const deleteSubImage = React.useCallback(
    (subImageId) => {
      axios
        .post('/api/community/expense_application/delete_image', {
          id: subImageId,
          expense_application_id: expenseApplication.id,
        })
        .then(() => {
          setExpenseApplicationImages((prev) =>
            prev.filter((content) => content.id !== subImageId)
          );
        })
        .catch(() => {
          alert('画像の削除に失敗しました。');
        });
    },
    [subImage1, subImage2, subImage3, subImage4, subImage5, subImage6, subImage7, subImage8, subImage9, subImage10]
  );

  const onChangeSubImage = React.useCallback(
    async (e) => {
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      file = await compressImage(file);

      let subImageIndex = Number(e.target.id);
      if (subImageIndex === 1) {
        setLoadingSub1(true);
      } else if (subImageIndex === 2) {
        setLoadingSub2(true);
      } else if (subImageIndex === 3) {
        setLoadingSub3(true);
      } else if (subImageIndex === 4) {
        setLoadingSub4(true);
      } else if (subImageIndex === 5) {
        setLoadingSub5(true);
      } else if (subImageIndex === 6) {
        setLoadingSub6(true);
      } else if (subImageIndex === 7) {
        setLoadingSub7(true);
      } else if (subImageIndex === 8) {
        setLoadingSub8(true);
      } else if (subImageIndex === 9) {
        setLoadingSub9(true);
      } else if (subImageIndex === 10) {
        setLoadingSub10(true);
      }
      let formData = new FormData();
      formData.append('expense_application_id', expenseApplication.id);
      formData.append('file', file);
      axios
        .post('/api/community/expense_application/upload_image', formData)
        .then((res) => {
          setExpenseApplicationImages((prev) => {
            return [...prev, res.data];
          });
        })
        .catch(() => {
          alert('画像のアップロードに失敗しました。');
        })
        .finally(() => {
          if (subImageIndex === 1) {
            setLoadingSub1(false);
          } else if (subImageIndex === 2) {
            setLoadingSub2(false);
          } else if (subImageIndex === 3) {
            setLoadingSub3(false);
          } else if (subImageIndex === 4) {
            setLoadingSub4(false);
          } else if (subImageIndex === 5) {
            setLoadingSub5(false);
          } else if (subImageIndex === 6) {
            setLoadingSub6(false);
          } else if (subImageIndex === 7) {
            setLoadingSub7(false);
          } else if (subImageIndex === 8) {
            setLoadingSub8(false);
          } else if (subImageIndex === 9) {
            setLoadingSub9(false);
          } else if (subImageIndex === 10) {
            setLoadingSub10(false);
          }
        });
    },
    [expenseApplication.id, subImage1, subImage2, subImage3, subImage4, subImage5, subImage6, subImage7, subImage8, subImage9, subImage10]
  );

  return (
    <div className="row flex-wrap overflow-auto">
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub1 ? (
          <Loader isActive={loadingSub1} />
        ) : subImage1.image_url_medium ? (
          <SubImage
            subImage={subImage1}
            updateSubImage={() => updateSubImage(1)}
            deleteSubImage={() => deleteSubImage(subImage1.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={1} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub2 ? (
          <Loader isActive={loadingSub2} />
        ) : subImage2.image_url_medium ? (
          <SubImage
            subImage={subImage2}
            updateSubImage={() => updateSubImage(2)}
            deleteSubImage={() => deleteSubImage(subImage2.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={2} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub3 ? (
          <Loader isActive={loadingSub3} />
        ) : subImage3.image_url_medium ? (
          <SubImage
            subImage={subImage3}
            updateSubImage={() => updateSubImage(3)}
            deleteSubImage={() => deleteSubImage(subImage3.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={3} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub4 ? (
          <Loader isActive={loadingSub4} />
        ) : subImage4.image_url_medium ? (
          <SubImage
            subImage={subImage4}
            updateSubImage={() => updateSubImage(4)}
            deleteSubImage={() => deleteSubImage(subImage4.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={4} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub5 ? (
          <Loader isActive={loadingSub5} />
        ) : subImage5.image_url_medium ? (
          <SubImage
            subImage={subImage5}
            updateSubImage={() => updateSubImage(5)}
            deleteSubImage={() => deleteSubImage(subImage5.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={5} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub6 ? (
          <Loader isActive={loadingSub6} />
        ) : subImage6.image_url_medium ? (
          <SubImage
            subImage={subImage6}
            updateSubImage={() => updateSubImage(6)}
            deleteSubImage={() => deleteSubImage(subImage6.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={6} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub7 ? (
          <Loader isActive={loadingSub7} />
        ) : subImage7.image_url_medium ? (
          <SubImage
            subImage={subImage7}
            updateSubImage={() => updateSubImage(7)}
            deleteSubImage={() => deleteSubImage(subImage7.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={7} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub8 ? (
          <Loader isActive={loadingSub8} />
        ) : subImage8.image_url_medium ? (
          <SubImage
            subImage={subImage8}
            updateSubImage={() => updateSubImage(8)}
            deleteSubImage={() => deleteSubImage(subImage8.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={8} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub9 ? (
          <Loader isActive={loadingSub9} />
        ) : subImage9.image_url_medium ? (
          <SubImage
            subImage={subImage9}
            updateSubImage={() => updateSubImage(9)}
            deleteSubImage={() => deleteSubImage(subImage9.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={9} />
          </a>
        )}
      </div>
      <div
        className="col-3 col-md-2 col-lg-2 bg-gray m-2 p-0 w-100"
        style={{ height: 90 }}
      >
        {loadingSub10 ? (
          <Loader isActive={loadingSub10} />
        ) : subImage10.image_url_medium ? (
          <SubImage
            subImage={subImage10}
            updateSubImage={() => updateSubImage(10)}
            deleteSubImage={() => deleteSubImage(subImage10.id)}
          />
        ) : (
          <a onClick={createImage}>
            <NonImage number={10} />
          </a>
        )}
      </div>
      <input
        id={1}
        name={subImage1.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef1}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={2}
        name={subImage2.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef2}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={3}
        name={subImage3.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef3}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={4}
        name={subImage4.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef4}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={5}
        name={subImage5.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef5}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={6}
        name={subImage6.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef6}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={7}
        name={subImage7.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef7}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={8}
        name={subImage8.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef8}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={9}
        name={subImage9.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef9}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
      <input
        id={10}
        name={subImage10.id}
        type="file"
        accept="image/png, image/jpeg"
        ref={subImageRef10}
        onChange={onChangeSubImage}
        style={{ display: 'none' }}
      />
    </div>
  );
};

const SubImage = ({ subImage, updateSubImage, deleteSubImage }) => (
  <div>
    <a onClick={updateSubImage}>
      <img
        className="w-100 object-fit-cover adjust-box-inner"
        type="image"
        id={subImage.id}
        src={subImage.image_url_medium}
      />
    </a>
    <a
      className="position-absolute bg-gray"
      style={{
        top: 0,
        right: 0,
        width: 24,
        height: 24,
        borderRadius: 12,
      }}
      onClick={deleteSubImage}
    >
      <p className="text-center text-fw-bold">×</p>
    </a>
  </div>
);

const NonImage = ({ number }) => (
  <div>
    <div className="w-100 object-fit-cover adjust-box-inner d-flex justify-content-end">
      <p className="bg-secondary text-white position-absolute top-0 pl-2 pr-2">
        {number}
      </p>
    </div>
    <div className="conteiner p-4">
      <div className="conteiner adjust-box adjust-box-3x2">
        <img
          src="/assets2019/img/icon_camera.svg"
          className="rounded w-100 object-fit-cover adjust-box-inner"
        />
      </div>
    </div>
  </div>
);

export default SectionImage;
